import { apiClient } from '@lib/httpClient/apiClient';
import {
  type IListTreatmentCategoriesEndpointResponse,
  listTreatmentCategoriesEndpoint,
} from '@lib/httpClient/endpoints/treatments/listTreatmentCategoriesEndpoint';

import type { IListTreatmentCategoriesOutputDTO } from './dtos/listCategories/IOutputData';
import type { ITreatmentRepository } from './ITreatmentRepository';

class TreatmentService implements ITreatmentRepository {
  public async listCategories(): Promise<IListTreatmentCategoriesOutputDTO> {
    const response =
      await apiClient.get<IListTreatmentCategoriesEndpointResponse>({
        path: listTreatmentCategoriesEndpoint(),
      });
    const output: IListTreatmentCategoriesOutputDTO = {
      list: response.list.map((item) => ({
        id: item.id,
        sku: item.sku,
        title: item.title,
      })),
    };
    return output;
  }
}

export const treatmentService = new TreatmentService();
